var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.503 2L16.333 6.83V16H2.33301V2H11.503ZM11.503 0H2.33301C1.23301 0 0.333008 0.9 0.333008 2V16C0.333008 17.1 1.23301 18 2.33301 18H16.333C17.433 18 18.333 17.1 18.333 16V6.83C18.333 6.3 18.123 5.79 17.743 5.42L12.913 0.59C12.543 0.21 12.033 0 11.503 0ZM4.33301 12H14.333V14H4.33301V12ZM4.33301 8H14.333V10H4.33301V8ZM4.33301 4H11.333V6H4.33301V4Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoads);
export default __webpack_public_path__ + "static/media/loads.bac10149e5ca60f25ab639fdd8013d1c.svg";
export { ForwardRef as ReactComponent };